import React,{useEffect} from "react";
import EditProfileContainer from "../../containers/EditProfileContainer/EditProfileContainer";
import Page from "../Page/Page";
import { useLocation } from "react-router";


type Props = {
    //user : any;
    whatever: string;  
};
const  EditProfilPage: React.FC<Props> = () => {       
            
    return (
        <>
        <div> 
            <EditProfileContainer></EditProfileContainer>        
        </div>      
       
        </>
    )
}
export default EditProfilPage;